const dev = {
    API_URL: "https://devcprchatbotapi.recoverypad.com/",
    DESTINATION_RULE: 'https://devcprapp.recoverypad.com/'
};


const production = {
    API_URL: "https://cprchatbotapi.recoverypad.com/",
    DESTINATION_RULE: 'https://cprchatbotapp.recoverypad.com/'
};

let config;
switch (process.env.REACT_APP_ENV) {
    case "prod":
        config = production;
        break;
    default:
        config = dev;
}
export const SERVICES = {
    API: config.API_URL,
    //Log Key
    LOGGER_KEY: 'e40c307f-d691-4a0a-81f8-1b13118e7710',
    //Log token
    LOGGER_OWNER_KEY: '39d436bd-ea8b-4b19-86e8-0037bc1f5573',
    DESTINATION_RULE: config.DESTINATION_RULE
}




